import './Search.scss';

declare global {
    interface Window {
        luigisBoxAutocompleteLoaded: () => void;
        AutoComplete?: (options: object, selector: string) => void;
    }
}

function initialize(
    searchInput: HTMLInputElement,
    searchOpenButton: HTMLButtonElement,
    searchCloseButton: HTMLButtonElement,
    searchOverlay: HTMLDivElement,
): void {
    function openOverlay() {
        searchOverlay.style.display = 'flex';
        searchInput.focus();
        searchOverlay.classList.add('search-bar__overlay--visible');
        document.documentElement.classList.add('-searchbar-open');
    }

    function closeOverlay() {
        document.documentElement.classList.remove('-searchbar-open');
        searchOverlay.classList.remove('search-bar__overlay--visible');
        searchOverlay.style.display = 'none';
        searchInput.blur();
        searchInput.value = '';
    }

    searchOpenButton.addEventListener('click', () => openOverlay());
    searchCloseButton.addEventListener('click', () => closeOverlay());

    const content = document.querySelector('.content');
    if (content) {
        content.addEventListener('click', () => closeOverlay());
    }

    window.addEventListener(
        'keydown',
        (event) => {
            if (event.key === 'Escape') {
                closeOverlay();
            }
        },
        false,
    );

    interface LuigisBoxResult {
        type: string;
        attributes: {
            articleNumber: string[];
        };
    }

    window.luigisBoxAutocompleteLoaded = () => {
        if (window.AutoComplete) {
            window.AutoComplete(
                {
                    Layout: 'grid',
                    TrackerId: '127032-145455',
                    Types: [
                        {
                            type: 'product',
                            name: 'Produkte',
                            placement: 'main',
                            attributes: ['articleNumber.hl'],
                        },
                        {
                            type: 'category',
                            name: 'Kategorien',
                            placement: 'others',
                        },
                        {
                            type: 'faq',
                            name: 'FAQ',
                            placement: 'others',
                        },
                        {
                            type: 'page',
                            name: 'Seiten',
                            placement: 'others',
                        },
                        {
                            type: 'makeUpTip',
                            name: 'Make-up Tipps',
                            placement: 'others',
                        },
                    ],
                    ShowAllTitle: 'Alle Ergebnisse anzeigen',
                    FormatForDisplay: (result: LuigisBoxResult) => {
                        if (result.type === 'product') {
                            result.attributes.articleNumber[0] = 'Art.-Nr.: ' + result.attributes.articleNumber[0];
                        }
                        return result;
                    },
                },
                '#header-search',
            );
        }
    };
    window.luigisBoxAutocompleteLoaded();
}

(function () {
    const searchInput = document.getElementById('header-search');
    const searchOpenButton = document.querySelector('.search-bar__button');
    const searchCloseButton = document.querySelector('.search-bar__close');
    const searchOverlay = document.querySelector('.search-bar__overlay');
    if (
        searchInput instanceof HTMLInputElement &&
        searchOpenButton instanceof HTMLButtonElement &&
        searchCloseButton instanceof HTMLButtonElement &&
        searchOverlay instanceof HTMLDivElement
    ) {
        initialize(searchInput, searchOpenButton, searchCloseButton, searchOverlay);
    }
})();
